import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.SimplePageLayout', {
    downloadMobileAppsText: 'Download our mobile apps',
});
